export default __webpack_public_path__ + "static/media/talks.aba36b49.jpg";